<div class="w-100">
  <div
    class="d-flex flex-column justify-content-center align-items-start w-100 px-3 pb-2"
  >

    <!-- Classification Title -->
    <div class="py-2">
        <span class="text-complementary-color-a fw-bold text-sub-title">
          {{language?.status || 'status' | titlecase}}:
        </span>
    </div>
    <div
    >
      <div
        *ngIf="loadingBulkStatusProcessResult"
        class="spinner-grow spinner-grow-sm text-complementary-color-a me-sm-1" role="status"
      ></div>
      <app-process-state
        *ngIf="!loadingBulkStatusProcessResult && !hasPermissions.value"
        [triggers]="'mouseenter:mouseleave'"
        container="body"
        placement="left"
        boundariesElement="viewport"
        [popover]="popTemplate"
        containerClass="task-warning"
        [popoverContext]="hasPermissions"
        [stateList]="state_list"
        [selectedState]="selected_state"
        [editable]="false"
        (onSelectState)="processStatusChange($event)"
      ></app-process-state>
      <app-process-state
        *ngIf="!loadingBulkStatusProcessResult && hasPermissions.value"
        [stateList]="state_list"
        [selectedState]="selected_state"
        [editable]="true"
        (onSelectState)="processStatusChange($event)"
      ></app-process-state>
    </div>
  </div>
</div>

<ng-template #popTemplate let-message="message">
  <div class="d-flex justify-content-start align-items-center pb-2">
    <span style="margin-left: -2px" class="material-symbols-sharp text-title text-warning p-0 me-2">
      gpp_bad
    </span>
    <span class="text-sub-title fw-semibold">{{language.bulkProcessPermissionHeader}}</span>
  </div>
  <div class="text-normal" *ngIf="message" [innerHTML]="message"></div>

</ng-template>
